<template>
  <div>
    <div id="divback" v-show="IsPlay" class="divbackground" style="display:none"></div>
    <div id="loading_panel" v-show="IsPlay" class="loading_panel">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
  </div>
</template>
<script>

export default ({
  name:'qLoading',
  data (){
    return {
      //LoadingAnimate:'', // Loading Animation Cycle Interval
      IsPlay:false, //
    }
  },
  methods :{
    show() {
      this.IsPlay = true;
      // this.PlayAnimate();
      // this.LoadingAnimate = setInterval(() => {
      //   this.PlayAnimate();
      // }, 4500);
    },

    stop(){
      this.IsPlay = false;
      // clearInterval(this.LoadingAnimate);
      // const ColorDiv = document.getElementById("divcolor");
      // ColorDiv.classList.remove('fillgauge');
      // ColorDiv.classList.remove('rotategauge');
      // ColorDiv.style.width='0px';
    },

    PlayAnimate() {
      if(this.IsPlay) {

        // 초기화 부분
        const BlackDiv = document.getElementById("divblack");
        BlackDiv.style.display ='block';
        const ColorDiv = document.getElementById("divcolor");
        ColorDiv.classList.remove('fillgauge');
        ColorDiv.classList.remove('rotategauge');
        ColorDiv.style.width='0px';

        setTimeout(() => {
          if(this.IsPlay) {
            ColorDiv.classList.add('fillgauge');
            //ColorDiv.style.width=document.getElementById("blackimg").clientWidth;  
            ColorDiv.style.width='135px';
          }
        }, 100);

        setTimeout(() => {
          if(this.IsPlay) {
            BlackDiv.style.display ='none';
            ColorDiv.classList.add('rotategauge');
          }
        }, 2100);
      }
    }
  }
})

</script>
<style scoped>
  .loading_panel {
    position:fixed; 
    top:50%; 
    left:50%; 
    z-index: 2147483647; 
    transform:translate(-50%,-50%); 
    width:auto; 
    height:auto;
  }
  #divblack {
    position:absolute;
  }
  #divcolor {
    width:0px; 
    overflow: hidden;
    position:absolute;
  }

  .divbackground {
    width:100vw;
    height:100vh;
    opacity: 0.8;
    display: block;
    left: 0;
    top: 0;
    background-color: gray;
    position:fixed;
    z-index: 	2147483646;
  } 
  .fillgauge {
    -webkit-transition: width 2s ease-in-out;
    -moz-transition: width 2s ease-in-out;
    -o-transition: width 2s ease-in-out;
    transition: width 2s ease-in-out;
  }
  .rotategauge {
    transform:rotateY(360deg);
    /* transform-origin: 50% 50%; */
    transition: all 2s;
  }
</style>